module.exports = __webpack_public_path__ + "img/rodilleras_espinilleras.cc5aed8c.png";